
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {LegalDocumentGroupGetFilterResponse} from './LegalDocumentGroupGetFilterResponse';

/**
 * LegalDocumentGroupGetFilterRequest struct
 */
class LegalDocumentGroupGetFilterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {number=} groupId
   * @param {boolean=} includeDisabled
   * @constructor
   */
  constructor (parent = new Request(), groupId = null, includeDisabled = null) {
    super()
    super.copy(parent)
    this.GroupId = groupId
    this.IncludeDisabled = includeDisabled
  }

  /**
   * Copy struct (shallow copy)
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @param {!LegalDocumentGroupGetFilterRequest} other Other struct
   * @returns {!LegalDocumentGroupGetFilterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.GroupId != null) {
      this.GroupId = UInt64.fromNumber(other.GroupId)
    } else {
      this.GroupId = null
    }
    if (other.IncludeDisabled != null) {
      this.IncludeDisabled = other.IncludeDisabled
    } else {
      this.IncludeDisabled = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @returns {!LegalDocumentGroupGetFilterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new LegalDocumentGroupGetFilterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new LegalDocumentGroupGetFilterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @param {!LegalDocumentGroupGetFilterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LegalDocumentGroupGetFilterRequest)) {
      throw new TypeError('Instance of LegalDocumentGroupGetFilterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      GroupId: ((this.GroupId != null) ? this.GroupId.toNumber() : null),
      IncludeDisabled: ((this.IncludeDisabled != null) ? this.IncludeDisabled : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return LegalDocumentGroupGetFilterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!LegalDocumentGroupGetFilterRequest} other Object value
   * @returns {!LegalDocumentGroupGetFilterRequest} Created struct
   */
  static fromObject (other) {
    return new LegalDocumentGroupGetFilterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return LegalDocumentGroupGetFilterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!LegalDocumentGroupGetFilterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6597
  }
}

export { LegalDocumentGroupGetFilterRequest };

/**
 * Fast Binary Encoding LegalDocumentGroupGetFilterRequest field model
 */
class FieldModelLegalDocumentGroupGetFilterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.GroupId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.IncludeDisabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.GroupId.fbeOffset + this.GroupId.fbeSize), buffer, this.GroupId.fbeOffset + this.GroupId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.GroupId.fbeSize + this.IncludeDisabled.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.GroupId.fbeExtra + this.IncludeDisabled.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLegalDocumentGroupGetFilterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6597
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupId.fbeSize

    if ((fbeCurrentSize + this.IncludeDisabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IncludeDisabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeDisabled.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!LegalDocumentGroupGetFilterRequest} fbeValue Default value, defaults is new LegalDocumentGroupGetFilterRequest()
   * @returns {!LegalDocumentGroupGetFilterRequest} LegalDocumentGroupGetFilterRequest value
   */
  get (fbeValue = new LegalDocumentGroupGetFilterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!LegalDocumentGroupGetFilterRequest} fbeValue LegalDocumentGroupGetFilterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.GroupId.fbeSize) <= fbeStructSize) {
      fbeValue.GroupId = this.GroupId.get()
    } else {
      fbeValue.GroupId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GroupId.fbeSize

    if ((fbeCurrentSize + this.IncludeDisabled.fbeSize) <= fbeStructSize) {
      fbeValue.IncludeDisabled = this.IncludeDisabled.get()
    } else {
      fbeValue.IncludeDisabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IncludeDisabled.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {!LegalDocumentGroupGetFilterRequest} fbeValue LegalDocumentGroupGetFilterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLegalDocumentGroupGetFilterRequest}
   * @param {LegalDocumentGroupGetFilterRequest} fbeValue LegalDocumentGroupGetFilterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.GroupId.set(fbeValue.GroupId)
    this.IncludeDisabled.set(fbeValue.IncludeDisabled)
  }
}

export { FieldModelLegalDocumentGroupGetFilterRequest };

/**
 * Fast Binary Encoding LegalDocumentGroupGetFilterRequest model
 */
class LegalDocumentGroupGetFilterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLegalDocumentGroupGetFilterRequest(this.buffer, 4)
  }

  /**
   * Get the LegalDocumentGroupGetFilterRequest model
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!FieldModelLegalDocumentGroupGetFilterRequest} model LegalDocumentGroupGetFilterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return LegalDocumentGroupGetFilterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLegalDocumentGroupGetFilterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @param {!LegalDocumentGroupGetFilterRequest} value LegalDocumentGroupGetFilterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @param {!LegalDocumentGroupGetFilterRequest} value LegalDocumentGroupGetFilterRequest value, defaults is new LegalDocumentGroupGetFilterRequest()
   * @return {!object} Deserialized LegalDocumentGroupGetFilterRequest value and its size
   */
  deserialize (value = new LegalDocumentGroupGetFilterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new LegalDocumentGroupGetFilterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new LegalDocumentGroupGetFilterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!LegalDocumentGroupGetFilterRequestModel}
   * @param {!number} prev Previous LegalDocumentGroupGetFilterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { LegalDocumentGroupGetFilterRequestModel };
LegalDocumentGroupGetFilterRequest.__has_response = true;
LegalDocumentGroupGetFilterRequest.__response_class = LegalDocumentGroupGetFilterResponse;
